import L from "leaflet";
import * as EsriLeaflet from "esri-leaflet";
import * as EsriLeafletVector from "esri-leaflet-vector";
import { ESRI_API_KEY } from "../../../config/_entrypoint";

if (!ESRI_API_KEY) {
  console.warn(
    "ESRI_API_KEY is not set. Please set it in client/.env to use esri BASEMAP_LIST. Defaulting to open street maps for local development."
  );
}

// Attach plugins to the L.esri namespace if not already present
if (!L.esri) {
  L.esri = EsriLeaflet;
}
if (!L.esri.Vector) {
  L.esri.Vector = EsriLeafletVector;
}

const getInitialState = () => {
  let BASEMAP_LIST = [
    { name: "Satellite", id: "arcgis/imagery" },
    { name: "Street", id: "open/streets" },
    { name: "Terrain", id: "arcgis/topographic" },
    { name: "Community", id: "arcgis/community" },
  ];
  if (!ESRI_API_KEY) {
    BASEMAP_LIST = [
      {
        name: "Open Street Maps",
        id: "OpenStreetMap",
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      },
    ];
  }

  return {
    BASEMAP_LIST: BASEMAP_LIST,
    BASEMAP_ACTIVE_ID: BASEMAP_LIST[0].id, // this can be changed to save to and from local storage later
  };
};

const state = getInitialState();

const getters = {
  BASEMAP_ACTIVE: (state) => {
    const bm = state.BASEMAP_LIST.find((b) => b.id === state.BASEMAP_ACTIVE_ID);
    if (bm && bm.url) {
      return L.tileLayer(bm.url, {
        attribution: bm.attribution,
      });
    } else if (bm) {
      return L.esri.Vector.vectorBasemapLayer(bm.id, {
        apiKey: ESRI_API_KEY,
      });
    }
  },
  BASEMAP_FACTORY: (state) => {
    const bm = state.BASEMAP_LIST.find((b) => b.id === state.BASEMAP_ACTIVE_ID);
    return () => {
      if (bm && bm.url) {
        return L.tileLayer(bm.url, {
          attribution: bm.attribution,
        });
      } else if (bm) {
        return L.esri.Vector.vectorBasemapLayer(bm.id, {
          apiKey: ESRI_API_KEY,
        });
      }
    };
  },
};

const mutations = {
  BASEMAP_RESET(state) {
    Object.assign(state, getInitialState());
  },
  BASEMAP_SET_ACTIVE(state, id) {
    state.BASEMAP_ACTIVE_ID = id;
  },
};

const actions = {};

export default {
  getInitialState,
  state,
  getters,
  mutations,
  actions,
};
